import HomeSlider from "./components/home_slider";

HomeSlider.initiates();
